module.exports = __webpack_public_path__ + "static/media/nasa.f8f6eeb9.jpg";